import { ConfiguredServiceFormPage } from "./ConfiguredServiceFormPage";
import {
  clientDirectoryFormConfig,
  clientFeedbackFormConfig,
  discoveryCallNotesFormConfig,
  generalSupportRequestFormConfig,
  kickoffCallPrepFormConfig,
  partnerReferralTrackerFormConfig,
  projectDashboardFormConfig,
} from "./adminFormConfigs";

export function AdminDiscoveryCallNotesPage() {
  return <ConfiguredServiceFormPage config={discoveryCallNotesFormConfig} />;
}

export function AdminKickoffCallPrepPage() {
  return <ConfiguredServiceFormPage config={kickoffCallPrepFormConfig} />;
}

export function AdminClientDirectoryPage() {
  return <ConfiguredServiceFormPage config={clientDirectoryFormConfig} />;
}

export function AdminProjectDashboardPage() {
  return <ConfiguredServiceFormPage config={projectDashboardFormConfig} />;
}

export function AdminPartnerReferralTrackerPage() {
  return <ConfiguredServiceFormPage config={partnerReferralTrackerFormConfig} />;
}

export function AdminClientFeedbackPage() {
  return <ConfiguredServiceFormPage config={clientFeedbackFormConfig} />;
}

export function AdminGeneralSupportRequestPage() {
  return <ConfiguredServiceFormPage config={generalSupportRequestFormConfig} />;
}
